import React from 'react';
import { useReveal } from './hooks/useReveal';
import Navbar from "./Components/Navbar/Navbar";
import Hero from "./Components/Home/Home";
import Products from "./Components/Products/Products";
import CaseStudies from "./Components/CaseStudies/CaseStudies";
import Enterprise from "./Components/Enterprise/Enterprise";
import About from "./Components/About/About";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";

function App() {
  useReveal();
  return (
    <>
      <div className="bg-grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Products />
        <CaseStudies />
        <Enterprise />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
